
import PricingButton from "@/components/main/pricing/PricingButton";
import RedHeadBox from "@/components/main/core/RedHeadBox";
import SearchCircle from "@/components/main/core/SearchCircle"

import data from "@/mixins/data";
import PricingTabButtonsLocator from "../PricingTabButtonsLocator";
import isMobile from "@/mixins/isMob";
export default {
  name: "ListingLocatorTab",
  data() {
    return {
      currentTab: 1,
      date: new Date(),
    }

  },
  components: { PricingButton, RedHeadBox, SearchCircle, PricingTabButtonsLocator, isMobile },
  mixins: [data, isMobile],
  methods: {
    datenow() {
      if (this.date.getMinutes())
        return `${this.date.getDate()}/${this.date.getMonth()+1}/${this.date.getFullYear()} ${this.date.getHours()}:${+this.date.getMinutes() <= 10 ? '0'+this.date.getMinutes() : this.date.getMinutes()}`
    },
    change(data) {
      this.currentTab = data
    }
  }

}
